import React, {Component} from 'react';
// import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';

// Elements
import LatestNewsSection from "../elements/latest-news-slider";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
// import waveBlue from "../../images/shap/wave-blue.png";
// import circleDots from "../../images/shap/circle-dots.png";
// import plusBlue from "../../images/shap/plus-blue.png";

class Faq extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Faq's</h1>
									{/* <nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Faq's</li>
										</ul>
									</nav> */}
								</div>
							</div>
							{/* <img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/> */}
						</div>
					</div>
					
					<section className="section-sp3">
						<div className="container">
							<div className="row">
								<div className="col-lg-6">
									<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
										<Accordion.Item eventKey="0">
											<Accordion.Header>What are the benefits of fluoride in oral care?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Fluoride helps strengthen tooth enamel, making it more resistant to decay. It also aids in remineralization and can be found in toothpaste, mouthwash, and tap water.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="1">
											<Accordion.Header>How often should I replace my toothbrush?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">It is recommended to replace your toothbrush or toothbrush head every 3-4 months, or sooner if the bristles are frayed. A worn-out toothbrush is less effective in cleaning your teeth.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="2">
											<Accordion.Header>Can stress affect my oral health?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Yes, stress can contribute to teeth grinding, jaw clenching, and can increase the risk of gum disease. Managing stress through relaxation techniques can benefit both oral and overall health.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="3">
											<Accordion.Header>What is the connection between diet and oral health?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">A balanced diet with limited sugary and acidic foods promotes good oral health. Nutrients like calcium, vitamin D, and phosphorus are essential for strong teeth and gums.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="4">
											<Accordion.Header>Are electric toothbrushes more effective than manual ones?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Electric toothbrushes can be more effective in removing plaque and preventing gingivitis, but proper technique with a manual toothbrush can also yield excellent results. The key is consistent, thorough brushing.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="5">
											<Accordion.Header>What are some natural remedies for maintaining fresh breath?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Chewing sugar-free gum, drinking plenty of water, and incorporating parsley, mint, and green tea into your diet can help combat bad breath and promote oral freshness.</p>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</div>
								<div className="col-lg-6">
									<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
											<Accordion.Item eventKey="0">
												<Accordion.Header>How often should I visit the dentist for regular check-ups?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">It is generally recommended to schedule dental check-ups every six months, but your dentist may suggest more frequent visits based on your individual oral health needs.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="1">
												<Accordion.Header>What is the best way to maintain good oral hygiene at home?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Practicing proper oral hygiene includes brushing your teeth twice a day with fluoride toothpaste, flossing daily, and using an antiseptic mouthwash to reduce bacteria in the mouth.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="2">
												<Accordion.Header>How can I alleviate tooth sensitivity?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Tooth sensitivity can be addressed by using a toothpaste specifically designed for sensitive teeth, avoiding acidic foods and drinks, and consulting your dentist to rule out any underlying issues such as cavities or gum recession.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="3">
												<Accordion.Header>What are the options for teeth whitening?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Professional teeth whitening treatments performed by a dentist are effective and safe. Additionally, at-home whitening kits with dentist supervision are available, offering convenience and gradual results.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="4">
												<Accordion.Header>Are dental X-rays safe, and how often are they necessary?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Dental X-rays are generally safe, as the exposure to radiation is minimal. The frequency of X-rays depends on your oral health needs; your dentist will recommend them when necessary to diagnose and monitor dental issues.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="5">
												<Accordion.Header>How can I replace a missing tooth?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Options for tooth replacement include dental implants, bridges, and dentures. Your dentist will assess your specific situation to recommend the most suitable option for restoring your smile and functionality.</p>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
								</div>
							</div>
						</div>
					</section>
					
					<LatestNewsSection />
					
				</div>
			
			</>
		);
	}
}

export default Faq;